import { render } from "./Footer.vue?vue&type=template&id=3f389758&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3f389758&scoped=true&lang=scss"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f389758"]])

export default __exports__